/* gallery-stylist.js  interactions for the inline "Book a Stylist" section.
   Selecting a location updates the book button's target variant. Booking adds
   that consultation variant to the cart and sends the shopper to the cart; if the
   selected variant carries a custom.calendar (Calendly) link, it opens that
   scheduler in a popup instead. Scoped to [data-section-type="gly-stylist"]. */
(function () {
  'use strict';

  var CALENDLY_LOADED = false;

  function loadCalendly() {
    return new Promise(function (resolve) {
      if (CALENDLY_LOADED && window.Calendly) { resolve(); return; }
      if (!document.querySelector('link[data-calendly]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.setAttribute('data-calendly', '');
        document.head.appendChild(link);
      }
      var existing = document.querySelector('script[data-calendly]');
      if (existing && window.Calendly) { CALENDLY_LOADED = true; resolve(); return; }
      var s = existing || document.createElement('script');
      s.setAttribute('data-calendly', '');
      s.src = 'https://assets.calendly.com/assets/external/widget.js';
      s.onload = function () { CALENDLY_LOADED = true; resolve(); };
      if (!existing) document.head.appendChild(s);
      else if (window.Calendly) { CALENDLY_LOADED = true; resolve(); }
    });
  }

  function section(el) { return el.closest('[data-section-type="gly-stylist"]'); }

  function selectLocation(btn) {
    var sec = section(btn);
    if (!sec) return;
    sec.querySelectorAll('[data-stylist-variant]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var book = sec.querySelector('[data-stylist-book]');
    if (book) {
      book.setAttribute('data-variant', btn.getAttribute('data-stylist-variant'));
      book.setAttribute('data-calendar', btn.getAttribute('data-calendar') || '');
    }
  }

  function book(btn) {
    var calendar = (btn.getAttribute('data-calendar') || '').trim();
    if (calendar) {
      loadCalendly().then(function () {
        if (window.Calendly) window.Calendly.showPopupWidget(calendar);
        else window.open(calendar, '_blank');
      });
      return;
    }
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = (err && (err.description || err.message)) || 'Try again';
        setTimeout(function () { btn.textContent = original; }, 2200);
      });
  }

  document.addEventListener('click', function (e) {
    var loc = e.target.closest('[data-stylist-variant]');
    if (loc && !loc.disabled) { e.preventDefault(); selectLocation(loc); return; }
    var bookBtn = e.target.closest('[data-stylist-book]');
    if (bookBtn && !bookBtn.disabled) { e.preventDefault(); book(bookBtn); return; }
  });

  /* Trim the stylist video: start (and optionally end) it at a set point, looping
     from the start rather than 0. */
  function wireVideoTrim() {
    document.querySelectorAll('.gly-stylist__video[data-video-start]').forEach(function (v) {
      var start = parseFloat(v.getAttribute('data-video-start')) || 0;
      var end = parseFloat(v.getAttribute('data-video-end')) || 0;
      if (!start && !end) return;
      function seekStart() { try { v.currentTime = start; } catch (e) {} }
      if (v.readyState >= 1) seekStart();
      v.addEventListener('loadedmetadata', seekStart);
      v.addEventListener('timeupdate', function () {
        if ((end > 0 && v.currentTime >= end) || v.currentTime < start - 0.1) seekStart();
      });
    });
  }
  if (document.readyState !== 'loading') wireVideoTrim();
  else document.addEventListener('DOMContentLoaded', wireVideoTrim);
})();
